export const CModules: { moduleID: number, moduleName: string } [] = [
  {
    moduleID: 1,
    moduleName: "Admin CMS All"
  },
  {
    moduleID: 2,
    moduleName: ""
  }
]
